import { TranslateService } from '@ngx-translate/core';
import { Model, ModelOrigin, PlanningOffset } from 'src/app/interfaces/api/model';
import { ModelService } from 'src/app/services/api/models/model.service';
import { Config } from '../../../interfaces/shared/config';
import { CalibratorDockingPanel } from './calibrator/calibrator.docking-panel';

const Autodesk = window.Autodesk;

interface OriginDockingPanelPamams {
    modelService: ModelService,
    translate: TranslateService,
    height: string,
    onOriginChange: (evt: ModelOrigin, save?: boolean) => void,
    model: Model

}

export class OriginDockingPanel extends Autodesk.Viewing.UI.DockingPanel {
    modelTableId = "1234"
    viewer: Autodesk.Viewing.GuiViewer3D;
    declare container: HTMLElement;
    modelTable!: HTMLElement;
    modelService: ModelService;
    translate: TranslateService;
    model: Model;

    colors = Config.colors;

    projectXY: [number, number] | undefined;
    projectLatLonXY: [number, number] | undefined;

    offset: { x: number; y: number; z: number; };
    origin: ModelOrigin;
    calibratorPanel: CalibratorDockingPanel | null = null;

    onOriginChange: (evt: ModelOrigin, save?: boolean) => void;
    
    constructor(viewer: Autodesk.Viewing.GuiViewer3D, container: HTMLElement, id: string, title: string, options: OriginDockingPanelPamams) {
        super(container, id, title, options);
        this.viewer = viewer;
        this.modelService = options.modelService;
        this.translate = options.translate;

        this.model = options.model;
        this.projectXY = options.model.origin.projectXY;
        this.projectLatLonXY = options.model.origin.projectLatLonXY;
        this.onOriginChange = options.onOriginChange;

        this.origin = this.model.origin;
        this.offset = options.model.offset;
        this.container.style.top = "10px";
        this.container.style.left = "10px";
        this.container.style.width = "350px";
        this.container.style.height = options.height || "500px";
        this.container.style.resize = "auto";
        this.modelTableId = 'models-table';

        this.buildModelTableHtml();
        this.updateModel.bind(this);
    }

    buildModelTableHtml(model: Model | null = null) {
        if (model) {
            this.model = model;
            this.origin = model.origin;
        }

        let existingDiv = document.querySelector(".docking-panel-container-solid-color-a.docking-panel-scroll#origin-panel-div");

        if (existingDiv) {
            existingDiv.remove();
        }

        var div = document.createElement('div');

        div.classList.add('docking-panel-container-solid-color-a', 'docking-panel-scroll')
        div.id = "origin-panel-div"
        div.style.height = "calc(100% - 40px)"
        div.style.overflowX = "hidden";

        var div2 = document.createElement('div');
        div2.classList.add('docking-panel-body');

        this.modelTable = document.createElement('div');
        this.modelTable.classList.add('viewer-origin')
        this.modelTable.id = 'model-table';

        this.loadAndRenderHtml(div).then(() => {
            div.appendChild(div2);
            this.container.appendChild(div);

            let up: any = document.getElementById("up")
            up.value = this.origin.up;

            this.init();
        });
    }

    changePlanningState(evt: Event) { }

    public init(reload = false) {
        let editCells: HTMLCollectionOf<Element> = document.getElementsByClassName('edit');

        if (editCells)
            for (let i = 0; i < editCells.length; i++) {
                let cell = editCells[i] as HTMLElement

                cell.addEventListener('change', (event: Event) => {
                    this.edit(event);
                })
            }

        let addCalibratorBtn = document.getElementById("add-calibrator");
        addCalibratorBtn?.addEventListener('click', () => {
            this.addCalibrator();
        })

        let editOffsetCells: HTMLCollectionOf<Element> = document.getElementsByClassName('edit-offset');

        if (editOffsetCells)
            for (let i = 0; i < editOffsetCells.length; i++) {
                let cell = editOffsetCells[i] as HTMLElement;

                cell.addEventListener('change', (event: Event) => {
                    this.editOffset(event);
                })
            }

        let addLevelBtn = document.getElementById("add-level");

        addLevelBtn?.addEventListener('click', () => {
            if (!this.model.levels)
                this.model.levels = [];

            let levelCount = this.model.levels.length;
            let z = this.model.levels[levelCount - 1]?.z || 0;
            this.model.levels.push({ name: "N" + levelCount, z: z + 3 });
            this.addLevelAndZone();
        })

        let addZoneBtn = document.getElementById("add-level-zone");
        addZoneBtn?.addEventListener('click', () => {
            if (!this.model.zones)
                this.model.zones = [];

            let zoneCount = this.model.zones.length;
            this.model.zones.push("A" + zoneCount);
            this.addLevelAndZone();
        });

        this.addLevelAndZone();
    }

    edit(e: Event) {
        var input = e.target as HTMLInputElement | HTMLSelectElement
        let value: string | number = input.value;
        var id: string = input.getAttribute('id')!;
        var type = input.getAttribute('type');

        if (type == 'number')
            value = parseFloat(value);

        var attrName = id.split(".")[0];

        if (attrName == "position") {
            const positionKey = id.split(".")[1] as keyof typeof this.origin.position;
            this.origin.position[positionKey] = value as number;
        } else if (/Angle$/.test(id)) {
            this.origin[id as 'xAngle' | 'yAngle' | 'zAngle'] = (value as number) * (Math.PI / 180);
        } else if (id == "scale") {
            this.origin["scale"] = value as number;
        } else if (id == "up") {
            this.origin["up"] = value as string;
        }

        if ((id == "zAngle" && this.origin.up == "z") || (id == "yAngle" && this.origin.up == "y"))
            this.origin.angle = Number(value);

        this.model.origin = this.origin;

        if (this.onOriginChange)
            this.onOriginChange(this.origin)
    }

    editLevel(e: Event) {
        var input = e.target as HTMLInputElement
        let value: string | number = input.value;
        var name = input.getAttribute('name')!;
        var type = input.getAttribute('type');

        if (type == 'number')
            value = parseFloat(value as string);

        let nameArray = name.split("-");
        var elementType = nameArray[0];
        var attrName = nameArray[1];
        var levelIndex = parseInt(nameArray[2]!);

        if (elementType == "level" && this.model.levels && this.model.levels[levelIndex]) {
            if (!this.model.levels)
                this.model.levels = [];

            if (attrName == "name") {
                this.model.levels[levelIndex]!["name"] = value as string;
            } else if (attrName == "z") {
                this.model.levels[levelIndex]!["z"] = value as number;
            }
        } else {
            if (!this.model.zones)
                this.model.zones = [];

            this.model.zones[levelIndex] = value as string;
        }

        if (this.onOriginChange)
            this.onOriginChange(this.origin)
    }

    editOffset(e: Event) {
        var input = e.target as HTMLInputElement
        let value = parseFloat(input.value);
        var name = input.getAttribute('name')!;

        if (!this.model.planningOffset)
            this.model.planningOffset = {} as PlanningOffset

        this.model.planningOffset[name as 'concreting' | 'wall' | 'other'] = value;

        if (this.onOriginChange)
            this.onOriginChange(this.origin)
    }

    updateOriginPanel(origin: ModelOrigin) {
        this.origin = origin;
    }

    updateModel(model: Model) {
        this.modelService.updateModel(model).subscribe(res => {
        })
    }

    addLevelAndZone() {
        if (!this.model.levels || !this.model.levels.length) {
            this.model.levels = [];
            this.model.levels.push({ name: "N" + this.model.levels.length, z: this.origin.position.z, height: 3 });
        }

        if (!this.model.zones || !this.model.zones.length) {
            this.model.zones = [];
        }

        let form = document.getElementById("level-form")!;
        form.innerHTML = '';

        let lines: Array<{ level?: string, levelZ?: number, zone?: string }> = this.model.levels.map((l, i) => {
            return { level: l.name, levelZ: l.z }
        })

        this.model.zones.forEach((z, i) => {
            if (lines[i]) {
                lines[i].zone = z;
            } else {
                lines.push({ zone: z })
            }
        })

        lines.forEach((l, i) => {
            let html = `<div class="form-inline row orientation-group">
                <div class="form-group col col-xs-4">
                    <input type="text" class="edit-level form-control input-sm" name="level-name-${i}" value="${l.level}">
                </div>
                <div class="form-group col col-xs-2">
                    <input type="number" class="edit-level form-control input-sm" name="level-z-${i}" value="${l.levelZ}">
                </div>`;

            if (l.zone) {
                html += `
                <div class="form-group col col-xs-4">
                    <input type="text" class="edit-level form-control input-sm" name="zone-name-${i}" value="${l.zone}">
                </div>`;
            }

            html += `</div>`;
            form.innerHTML += html;
        })

        let editCells: HTMLCollectionOf<Element> = document.getElementsByClassName('edit-level');

        if (editCells)
            for (let i = 0; i < editCells.length; i++) {
                let cell = editCells[i] as HTMLElement

                cell.addEventListener('change', (event: Event) => {
                    this.editLevel(event);
                })
            }
    }

    addCalibrator() {
        if (this.calibratorPanel != null) {
            this.calibratorPanel.uninitialize();
            this.calibratorPanel = null;
        }

        this.calibratorPanel = new CalibratorDockingPanel(this.viewer, this.viewer.container, 'calibratorDockingPanel', 'Calibrator', {
            translate: this.translate,
            viewer: this.viewer,
            model: this.model,
            updateModel: this.updateModel,
            updateOrigin: this.updateOrigin,
            modelService: this.modelService,
            onOriginChange: this.onOriginChange,
            updateOriginPanel: this.updateOriginPanel
        });

        const titleDiv = this.viewer.container.querySelector('.docking-panel-title[data-i18n="Calibrator"]');
        if (titleDiv && !titleDiv.textContent?.trim()) {
            titleDiv.textContent = "Calibrator";
        }

        this.calibratorPanel.setVisible(true);
        this.calibratorPanel.init();
    }

    updateOrigin(latLon: { lat: number, lon: number }, projectLatLonXY: [number, number] | null = null): Model {
        this.origin.position["lat"] = latLon.lat;
        this.origin.position["lon"] = latLon.lon;

        if (projectLatLonXY)
            this.origin.projectLatLonXY = projectLatLonXY;

        this.model.origin = this.origin;
        return this.model;
    }

    async loadAndRenderHtml(div: HTMLDivElement) {
        const template = await this.loadHtmlTemplate('viewer/origin/origin-extension/origin-extension.html');
        
        const variables = {
            viewer_origin: this.translate.instant('viewer.origin'),
            viewer_add_calibrator: this.translate.instant('viewer.calibration.model'),
            viewer_position: this.translate.instant('viewer.position'),
            viewer_longitude: this.translate.instant('viewer.lon'),
            viewer_latitude: this.translate.instant('viewer.lat'),
            viewer_angle_xyz: this.translate.instant('viewer.angle_xyz'),
            viewer_camera_up: this.translate.instant('viewer.camera_up'),
            viewer_add_level: this.translate.instant('viewer.add_level'),
            viewer_add_level_zone: this.translate.instant('viewer.add_level_zone'),
            viewer_level: this.translate.instant('viewer.level'),
            viewer_z: this.translate.instant('viewer.z'),
            viewer_levelZone: this.translate.instant('viewer.levelZone'),
            planning_frag_offset: this.translate.instant('planning.frag_offset'),
            planning_concreting: this.translate.instant('planning.concreting'),
            planning_wall: this.translate.instant('planning.wallCEP'),
            planning_other: this.translate.instant('planning.other'),

            origin_position_lon: this.origin.position.lon,
            origin_position_lat: this.origin.position.lat,
            origin_position_x: this.origin.position.x,
            origin_position_y: this.origin.position.y,
            origin_position_z: this.origin.position.z,
            origin_scale: this.origin.scale,
            origin_angle: this.origin.angle,
            origin_up: this.origin.up,

            geometry_scale: this.translate.instant('geometry.scale'),
            geometry_angle: this.translate.instant('geometry.angle'),

            xAngle: this.origin.xAngle ? (180 / Math.PI * this.origin.xAngle).toFixed(2) : 0,
            yAngle: this.origin.yAngle ? (180 / Math.PI * this.origin.yAngle).toFixed(2) : 0,
            zAngle: this.origin.zAngle ? (180 / Math.PI * this.origin.zAngle).toFixed(2) : 0,

            oConcreting: this.model.planningOffset?.concreting || 9,
            oWall: this.model.planningOffset?.wall || 6,
            oOther: this.model.planningOffset?.other || 3,
        };

        div.innerHTML = this.renderTemplate(template, variables);
    }

    async loadHtmlTemplate(path: string): Promise<string> {
        const response = await fetch(path);
        return await response.text();
    }

    renderTemplate(template: string, variables: Record<string, string | number>) {
        return template.replace(/{{(.*?)}}/g, (_, key) => String(variables[key.trim()] ?? ''));
    }
}